// extracted by mini-css-extract-plugin
module.exports = {"headerScrollShadow":"Header_headerScrollShadow__yNGp4","scrollShadow":"Header_scrollShadow__PSf97"};